// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__CUwrG","sendOtp":"AuthorizeToLogin_sendOtp__lKIcS"};